/**
 * Brand Configuration — Single Source of Truth
 *
 * This config drives all **internal / dashboard** branding:
 *   Sidebar, Auth screens, PWA manifest, listing-page defaults, edge-function fallbacks.
 *
 * PUBLIC WEBSITE pages (Home, Blog, Contact, BuyerIntake, SellerIntake, Terms, Privacy)
 * are hardcoded as FBA and do NOT read from this file.
 *
 * Listing pages support per-listing brand overrides via the `brand_logo_url` and
 * `brand_name` columns on the `listings` table.  When those columns are null the
 * listing falls back to the values defined here.
 *
 * ─── RULES ───
 * 1. New internal pages MUST import `BRAND` from this file — never hardcode names/URLs.
 * 2. Edge functions read brand identity from `app_settings` rows, NOT this file.
 * 3. To change the platform identity, update the values below and redeploy.
 */

import logoLight from '@/assets/logo-light.svg';
import logoDark from '@/assets/logo-dark.svg';

interface BrandConfig {
  /** Display name shown in sidebar, auth screens, PWA */
  platformName: string;
  /** Tagline shown on the auth screen */
  platformTagline: string;

  /** Light-mode logo (ES module import) */
  logoLightUrl: string;
  /** Dark-mode logo (ES module import) */
  logoDarkUrl: string;
  /** Alt text for logo images */
  logoAlt: string;

  /** PWA manifest full name */
  pwaName: string;
  /** PWA manifest short name */
  pwaShortName: string;

  /** Default title suffix for public listing pages (overridden per-listing) */
  listingTitleSuffix: string;
  /** Default logo URL for public listing pages (overridden per-listing) */
  listingLogoLightUrl: string;
  listingLogoDarkUrl: string;
}

export const BRAND: Readonly<BrandConfig> = {
  platformName: 'Frankly Core',
  platformTagline: 'Deal Origination Platform',

  logoLightUrl: logoLight,
  logoDarkUrl: logoDark,
  logoAlt: 'Frankly Advisors',

  pwaName: 'Frankly',
  pwaShortName: 'Frankly',

  

  listingTitleSuffix: 'Frankly Advisors',
  listingLogoLightUrl: logoLight,
  listingLogoDarkUrl: logoDark,
} as const;
